export default {
  translations: {
    login: {
      welcomeTitle: 'Boas-vindas',
      importantMessage: 'Toda a conversa com o chat será gravada e pode ser auditada pela MJV.',
      description: 'Por favor, entre com seu login corporativo.',
      loginLabel: 'Login',
      loginPlaceholder: 'Digite seu nome.sobrenome',
      loginPattern: 'Seu [Login] deve conter entre 3 a 260 caracteres',
      passwordLabel: 'Senha',
      passwordPlaceholder: 'Digite sua senha',
      passwordPattern: 'Sua [Senha] deve conter entre 5 a 300 caracteres',
      buttonMessageOk: 'ACESSAR',
      buttonMessageWait: 'AGUARDE...'
    },
    home: {
      textBreadcrumb: 'Começando com o Iron!',
      welcomeMessage: 'Bem-vindo ao IRON',
      description: 'Converse com um dos nosso agentes (IAs) e melhore o desempenho do seu trabalho!',
      callToAction: 'Experimente nossas IAs',
      agentAll: 'Geral',
      descriptionAgentAll: 'Tire dúvidas sobre temas diversos, sem a necessidade de um foco específico para a conversa.',
      agentHistoryUser: 'Historia de Usuário',
      descriptionAgentHistoryUser: 'Especialista em criar histórias de usuário para o seu projeto.',
      agentPointFunction: 'Ponto de Função',
      descriptionAgentPointFunction: 'Especialista em cálculo de pontos de função para o seu projeto.',
      agentBackLog: 'Backlog',
      descriptionAgentBackLog: 'Especialista na criação de backlogs para o seu projeto.',
      agentDev: 'Desenvolvimento',
      descriptionAgentDev: 'Especialista em desenvolvimento de novos recursos e manutenção do seu sistema.',
      agentCasesOfTests: 'Casos de Testes',
      descriptionAgentCasesOfTests: 'Especialista na criação de cenários de teste para o seu projeto.',
      agentQA: 'QA',
      descriptionAgentQA: 'Especialista em garantia de qualidade e testes automatizados de software.',
      agentVulnerabilities: 'Vulnerabilidades',
      descriptionAgentVulnerabilities: 'Especialista em corrigir vulnerabilidades do seu sistema.',
      agentFortify: 'Fortify',
      descriptionAgentFortify: 'Especialista em correções de vulnerabilidades apontadas pelo Fortify.',
      agentSupport: 'Sustentação',
      descriptionAgentSupport: 'Especialista em fornecer suporte para o seu projeto.',
      agentSaude: 'Bradesco Saúde',
      descriptionAgentSaude: 'Especialista em perguntas e respostas sobre o aplicativo Bradesco Saúde.',
      buttonChat: 'Conversar',
      agentAccessibility: 'Acessibilidade',
      descriptionAccessibility: 'Especialista em fornecer acessibilidade ao seu projeto',
      agentQualys: 'Qualys',
      descriptionAgentQualys: 'Especialista em corrigir vulnerabilidades apontadas pelo Qualys.',
    },
    menu: {
      iasSection: 'Inteligências',
      iaGeral: 'Geral',
      iaUserHistory: 'Historia de Usuário',
      iaPointFunction: 'Ponto de Função',
      iaBacklog: 'Backlog',
      iaDev: 'Dev',
      iaTestCase: 'Casos de Testes',
      iaQA: 'QA',
      iaVulnerabilities: 'Vulnerabilidades',
      iaFortify: 'Fortify',
      iaSupport: 'Sustentação',
      iaSupportAbs: 'Bradesco Saúde',
      historySection: 'Histórico',
      historyMessageSelect: 'Selecione uma inteligência.',
      historyNull: 'Nenhum histórico disponível.',
      dashboardSection: 'Dashboard de Uso',
      panelAdminSection: 'Painel Administrativo',
      panelConfigSection: 'Configurações',
      logout: 'Sair',
      iaAccessibility: 'Acessibilidade',
      iaQualys: 'Qualys',
      iaSwagger: 'Swagger',
    },
    chatsBreadcrumbs: {
      iaTitle: 'Inteligências Artificiais',
      iaGeral: 'Geral',
      iaUserHistory: 'Historia de Usuário',
      iaPointFunction: 'Ponto de Função',
      iaBacklog: 'Backlog',
      iaDev: 'Desenvolvimento (Dev)',
      iaTestCase: 'Casos de Testes',
      iaQa: 'QA',
      iaVulnerability: 'Vulnerabilidades',
      iaFortify: 'Fortify',
      iaSupport: 'Sustentação',
      iaAccessibility: 'Acessibilidade',
      iaSupportAbs: 'Sustentação App Bradesco Saúde',
      iaFunctionPoint: 'Ponto de Função',
      iaQualys: 'Qualys',
      details: 'Detalhes',
      iaSwagger: 'Swagger',

    },
    chatWelcomeBlock: {
      title: 'Como eu posso te ajudar?'
    },
    chatForms: {
      textAreaPlaceholder: 'Digite uma Mensagem ao Iron',
      selectDefault: 'Selecione...',
      continueButton: 'Continuar geração',
    },
    chatThinking: {
      messages: [
        'Pensando...',
        'Analisando sua pergunta...',
        'Consultando o conhecimento...',
        'Preparando a melhor resposta...',
        'Conectando as ideias...',
        'Quase lá...'
      ]
    },
    iaDevModal: {
      title: 'Adicione seu código aqui:',
      fileLabel: 'Carregar arquivo de código',
      filePlaceholder: 'Clique ou arraste um arquivo aqui',
      fileSupport: 'Suporta arquivos .js, .py, .java, etc.',
      languageLabel: 'Selecione a linguagem do arquivo',
      languageUndefined: 'Linguagem indefinida',
      languageUndefinedMessage: 'Linguagem indefinida, alguns recursos podem não funcionar da maneira esperada.',
      buttonSend: 'Enviar',
      buttonCancel: 'Cancelar',
    },
    overlayQA: {
      titleOverlay: 'Configurações do Agente',
      description: 'Selecione as opções abaixo para obter uma resposta mais precisa de nossos agentes.',
      title1: 'Qual o tipo de teste você quer realizar?',
      description1: 'Escolha o tipo de teste que deseja realizar. As opções podem incluir teste manuais e testes automatizados.',
      ariaLabel1: 'Selecione o tipo de teste',
      title2: 'Qual nível de teste você deseja realizar?',
      description2: 'Defina o nível do teste que você quer aplicar, que pode variar de testes unitários, integração e end-to-end.',
      ariaLabel2: 'Selecione o nível de teste',
      title3: 'Qual framework será aplicado a ele?',
      description3: 'Escolha o framework que você usará para realizar o teste. Pode incluir opções como Cucumber, Cypress, Selenium e etc.',
      ariaLabel3: 'Selecione o framework',
      title4: 'Qual a linguagem de programação usada?',
      description4: 'Selecione a linguagem de programação que você está utilizando para os testes. As opções podem incluir Java, Python, JS e etc.',
      ariaLabel4: 'Selecione a linguagem de programação',
      buttonSave: 'Salvar Configurações',
      manual: 'Testes Manuais',
      automated: 'Testes Automatizados',
      endToEnd: 'End-to-End',
      integrated: 'Integradoções/Serviços',
      unit: 'Unitário'
    },

    overlaySwagger: {
      titleOverlay: 'Configurações do Projeto',
      description: 'Preencha os campos abaixo para criar seu projeto.',
      projectName: 'Nome do Projeto',
      projectNameInputText: 'Digite o nome do projeto',
      projectGroup: 'Grupo',
      projectGroupDescription: 'com.grupo',
      projectPackage: 'Pacote',
      projectPackageDescription: 'com.pacote',
      projectClient: 'Cliente',
      projectType: 'Tipo de Projeto',
      springBootVersion: 'Versão do Spring Boot',
      developmentLang: 'Linguagem de Programação',
      javaVersion: 'Versão do Java',
      dependence: 'Dependências',
      projectDescription: 'Descrição',
      projectDescriptionInput: 'Informe a descrição do projeto',
      swaggerFile: 'Arquivo do Swagger',
      saveBtn: 'Salvar',   
    },
    overlayVulnerabilities: {
      titleOverlay: 'Configurações do Projeto',
      description: 'Selecione as opções abaixo para obter uma resposta mais precisa de nossos agentes.',
      title1: 'Qual o tipo de vulnerabilidade que você deseja corrigir?',
      description1: 'Escolha o tipo de erro em que a sua aplicação precisa acionar.',
      ariaLabel1: 'Selecione o tipo de teste',
      buttonSave: 'Salvar Configurações',
      none: 'Nenhum',
      critical: 'Crítico',
      high: 'Alto',
      medium: 'Médio',
      low: 'Baixo'
    },
    iaFortify: {
      detailsVulnerabilities: 'Detalhes da Vulnerabilidade',
      category: 'Categoria',
      nameOfFile: 'Nome do Arquivo',
      numberOfLine: 'Número da Linha',
      path: 'Caminho',
      directory: 'Diretório',
      csvFile: 'Arquivo CSV',
      selectDirectory: 'Selecionar Diretório',
      selectCSV: 'Selecionar um CSV',
      processSheet: 'Processar Planilha',
      welcomeMessage: 'Bem-vindo! Por favor, selecione um diretório e um arquivo CSV para começar.',
      vulnerabilities: 'Vulnerabilidades',
      openWithFortify: 'Abrir com Fortify',
      selected: 'Selecionado',
      notSelected: 'Não selecionado',
      lineNotSpecified: 'Linha não especificada',
      title: 'Adicione o relatório do Fortify aqui:',
      fileLabel: 'Carregar relatório do Fortify',
      filePlaceholder: 'Clique ou arraste um arquivo aqui',
      fileSupport: 'Suporta arquivos .xml',
      buttonSend: 'Enviar',
      buttonCancel: 'Cancelar',
      syncronized: 'Sincronizado',
      notSyncronized: 'Não Sincronizado',
      dirSelected: 'Pasta Selecionada',
      dirUnfound: 'Pasta esperada',
      paths: 'Pastas',
      overlayMessage: "Mediante a vulnerabilidade encontrada, por favor, corrija o problema."
    },
    iaQualys: {
      detailsVulnerabilities: 'Detalhes da Vulnerabilidade',
      openWithQualys: 'Abrir com Qualys',
      selected: 'Selecionado',
      notSelected: 'Não selecionado',
      welcomeMessage: 'Bem-vindo! Por favor, selecione um diretório e um arquivo CSV para começar.',
      selectCSV: 'Selecionar um CSV',
      processSheet: 'Processar Planilha',
      csvFile: 'Arquivo CSV',
      vulnerabilities: 'Vulnerabilidades',
      ip: 'IP',
      title: 'Título',
      port: 'Porta',
      action: 'Ação',
      overlayMessage: "Mediante a vulnerabilidade encontrada, por favor, corrija o problema."
    },
    chatNotFound: {
      mainTitle: 'Chat não encontrado!',
      title: 'Chat não encontrado 🤖',
      message: 'A página que você estava procurando não foi encontrada! Clique no botão abaixo para voltar à página inicial.',
      buttonMessage: 'Voltar para Home'
    },
    dashboardUsage: {
      all: 'Todos',
      tokensSpent: 'Tokens Gastos',
      estimativeValue: 'Valor Estimado',
      spentInTokens: 'Gastos em Tokens',
      spentInTokensDolars: 'Gastos em Tokens (Dólares)',
      interactions: 'Interações',
      interactionsByContexts: 'Interações por Contextos',
    },
    adminPanel: {
      breadcrumb: 'Painel Administrativo Global',
      title: 'Painel Administrativo 🔒',
      description: 'Crie, altere e exclua as permissões dos usuários que acessam a plataforma!',
      buttonCreateUser: 'Criar Usuário',
      username: 'Nome de Usuário',
      typeUser: 'Papel do Usuário',
      permission: 'Permissão do Usuário',
      actions: 'Ações',
      newUser: 'Novo Usuário',
      close: 'Fechar',
      usersNotFound: 'Nenhum usuário encontrado.',
      nameSurname: 'Nome.Sobrenome',
      updateUser: 'Atualizar Usuário',
      editUser: 'Editar Usuário',
    },
    profilePanel: {
      breadcrumb: 'Configurações do Perfil',
      myData: 'Meus Dados',
      loginLabel: 'Login',
      positionLabel: 'Cargo',
      createdAtLabel: 'Data de Registro',
      trialPeriodLabel: 'Período de Teste (dias)',
      trialPeriodRemainingDaysLabel: 'Dias Restantes',
      spentTokensLabel: 'Total de Tokens Gastos',
      trialRemainingTokensLabel: 'Tokens Restantes',
      save: 'Salvar Alterações',
      support: 'Suporte',
      descriptionSupport: 'Em caso de dúvidas entre em contato com o suporte do Iron no e-mail ao lado: ',
      idioms: "Selecione um Idioma: ",
      ptBr: "Português do Brasil (pt-BR)",
      enUs: "Inglês (en-Us)",
      es: "Espanhol (es)",
      cannotChangeYourOwnUser: 'Você não pode mudar a permissão do seu próprio usuário.',
      error: 'Erro!',
    },
    FortifyFileInputErrors: {
      notSuported: 'Tipo de arquivo não suportado! Escolha um arquivo .csv, .xlsx, .json, .txt, .docx, .doc, .pdf ou .feature',
      uploadFile: 'Erro ao carregar o arquivo.',
      error: 'Erro!',
    },
    downloadDocumentMessage: {
      loading: 'Construindo documento...',
      success: 'Baixar documento'
    },
    downloadSheetMessage: {
      loading: 'Construindo planilha...',
      success: 'Baixar Planilha'
    },
    overlayAccessibility: {
      titleOverlay: 'Configurações do Agente de Acessibilidade',
      description: 'Especialista em fornecer acessibilidade ao seu projeto.',
      modalTitleUrlParser: 'Obter HTML a partir de uma URL',
      modalDescriptionUrlParser: 'Irei acessar o site solicitado e analisar o HTML dele.',
      buttonOpenUrlParser: 'Abrir Extrator por URL',
      modalTitleAccessibility: 'Fazer upload ou colar o código',
      modalDescriptionAccessibility: 'Você pode enviar ou colar o seu código a ser analisado.',
      buttonOpenAccessibility: 'Inserir código HTML',
    },
    accessibilityModalFile: {
      title: 'Carregar Código HTML',
      fileLabel: 'Carregar arquivo de código a ser analisado',
      fileLabelHint: 'Clique ou arraste um arquivo aqui para enviar.',
      sendCode: "Enviar Código",
      cancelBtn: "Cancelar",
      characterLimit: "O conteúdo possui mais de 250.000 caracteres.",
    },
    accessibilityModalUrl: {
      title: "Analisar URL",
      placeholder: "Insira a URL do site que deseja extrair o HTML",
      analyse: "Extrair HTML",
      sendCode: "Enviar Código",
      cancelBtn: "Cancelar",
      loading: "Aguarde...",
      error: "Tente novamente colocando http:// ou https:// na frente da URL.",
      characterLimit: "O conteúdo possui mais de 250.000 caracteres.",
    },
    agents: {
      geral: {
        name: "Geral",
        description:
          "Eu sou um Modelo de Linguagem desenvolvido pela MJV Technology & Innovation, parte do sistema de IA conhecido como Iron. Meu objetivo é auxiliar os funcionários da MJV em uma ampla gama de tópicos, proporcionando respostas informativas e contextualmente relevantes. Estou aqui para discutir e fornecer informações sobre tecnologia, ciência, arte, conhecimento geral e outros assuntos que possam ser úteis no seu dia a dia profissional.",
      },
      historiaDeUsuario: {
        name: "História de Usuário",
        description:
          "Eu sou um agente especialista em análise de negócios, parte do sistema Iron desenvolvido pela 'MJV Technology & Innovation'. Estou aqui para ajudar você na criação e detalhamento de histórias de usuários para software web e mobile, seguindo práticas Agile, Scrum, Kanban e design centrado no ser humano.",
      },
      pontoDeFuncao: {
        name: "Ponto de Função",
        description:
          "Eu sou um agente especialista em Análise de Pontos de Função (APF), parte do sistema de IA desenvolvido pela 'MJV Technology & Innovation'. Meu foco é classificar corretamente as funções de um sistema como Processos Elementares (PE) ou Dados, seguindo rigorosamente as regras e diretrizes estabelecidas.",
      },
      backlog: {
        name: "Backlog",
        description:
          "Eu sou parte do Iron, um sistema de IA desenvolvido pela 'MJV Technology & Innovation'. Especificamente, sou um agente especialista em transformar histórias de desenvolvimento de software em épicos, histórias, tarefas e subtarefas para criar e estruturar o backlog de projetos ou produtos de software. Meu objetivo é garantir que cada item do backlog seja bem definido, claro e executável pela equipe de desenvolvimento, contribuindo para o sucesso do projeto.",
      },
      dev: {
        name: "Dev",
        description:
          "Eu sou um agente especialista em desenvolvimento de software da MJV Technology & Innovation. Estou aqui para ajudar você a abordar e resolver questões relacionadas ao desenvolvimento de software, aplicando as melhores práticas de programação, como divisão de responsabilidade, tratamento de erros, princípios SOLID e outras práticas recomendadas.",
      },
      casosDeTestes: {
        name: "Casos de Testes",
        description:
          "Eu sou um agente especializado em testes de software fazendo parte do sistema de IA Iron, desenvolvido pela MJV Technology & Innovation. Estou aqui para ajudar na criação, planejamento, execução e documentação de casos de teste detalhados para garantir a qualidade e funcionalidade dos sistemas de software.",
      },
      qa: {
        name: "QA",
        description:
          "Eu sou um agente especialista em QA, parte do sistema de IA desenvolvido pela MJV Technology & Innovation, focado em garantir a qualidade do software. Minha função é ajudar a conceber e implementar estratégias de teste, especialmente automatizados, para assegurar que os aplicativos funcionem conforme esperado.",
      },
      vulnerabilidade: {
        name: "Vulnerabilidade",
        description:
          "Eu sou um agente especializado em segurança de software, parte do sistema de IA conhecido como Iron, desenvolvido pela 'MJV Technology & Innovation'. Meu papel é ajudá-lo a identificar, corrigir e prevenir erros e vulnerabilidades em seu software, garantindo que seu código seja seguro, robusto e confiável.",
      },
      fortify: {
        name: "Fortify",
        description:
          "Eu sou um agente especializado em segurança de software, parte do sistema de IA conhecido como Iron, desenvolvido pela 'MJV Technology & Innovation'. Meu papel é analisar pastas de código-fonte em busca de vulnerabilidades de segurança, fornecendo informações detalhadas sobre como corrigi-las e garantir que seu software seja seguro e confiável.",
      },
      support: {
        name: "Support",
        description:
          "Eu sou um agente de inteligência artificial especializado em Sustentação de Sistemas. Minha função principal é ajudar na análise e solução de incidentes em sistemas de software, utilizando um histórico de incidentes anteriores e melhores práticas de suporte técnico.",
      },
      acessibilidade: {
        name: "Acessibilidade",
        description:
          "Eu sou um agente especializado em acessibilidade de software, parte do sistema de IA conhecido como Iron, desenvolvido pela 'MJV Technology & Innovation'. Meu objetivo é ajudar você a tornar seu software acessível a todos os usuários, incluindo pessoas com deficiência visual, auditiva, motora e cognitiva, seguindo as diretrizes de acessibilidade da Web (WCAG).",
      },
      bradescoSaude: {
        name: "Bradesco Saúde",
        description:
          "Eu sou um agente especialista em sistemas de Perguntas Frequentes (FAQ) voltado para o App Bradesco Saúde. Meu objetivo é ajudar você a encontrar respostas precisas e atualizadas para suas dúvidas, utilizando uma base de conhecimento que suporta vários formatos de arquivo como Docx, XLS, XLSX e TXT. Se precisar de qualquer assistência relacionada a problemas de acesso, cadastro, carteirinha, Idwall, reembolso ou token no App Bradesco Saúde, estou aqui para ajudar!",
      },
      qualys: {
        name: "Qualys",
        description:
          "Eu sou um agente especializado em segurança de rede, parte do sistema de IA conhecido como Iron, desenvolvido pela 'MJV Technology & Innovation'. Meu papel é ajudá-lo a identificar, corrigir e prevenir vulnerabilidades em sua rede, garantindo que seus sistemas e dados estejam seguros e protegidos contra ameaças.",
      },
    },
    alerts: {
      updateInProgress: {
        title: "Atualização em Progresso!",
        message:
          "O Iron está passando por atualizações e pode ficar fora do ar temporariamente. Obrigado pela compreensão!",
      },
    },
    common: {
      close: "Fechar",
    },
    history: {
      title: "Histórico de Conversa",
      description: "Acesse o histórico de conversas realizado com um de nossos agentes.",
      searchForName: "Buscar por titulo:",
      searchForNamePlaceholder: "Digite o titulo...",
      searchFor: "Filtrar por:",
      allAgents: "Todos os agentes",
      tableAgent: "Agente",
      tableTitle: "Título",
      tableDate: "Data",
      tableAction: "Ações",
      reopenChat: "Reabrir Chat",
      edit: "Editar",
      remove: "Remover",
      chatNameGeral: "Geral",
      chatNameUserHistory: "História de Usuário",
      chatNameBacklog: "Backlog",
      chatNameDev: "Desenvolvimento",
      chatNameTestCase: "Casos de Testes",
      chatNameQA: "QA",
      chatNameSwagger: "Swagger",
      chatNameVulnerability: "Vulnerabilidades",
      chatNameFortify: "Fortify",
      chatNameAccessibility: "Acessibilidade",
      chatNameSupportAbs: "Bradesco Saúde",
      chatNameSupport: "Sustentação",
      chatNameFunctionPoint: "Ponto de Função",
      backendGetDataError: "Erro ao buscar dados do back-end:",
      erroToLoadData: "Erro ao carregar dados",
      editHistoryModalTitle: "Editar titulo do histórico",
      editHistoryModalInputPlaceholder: "Digite o novo nome",
      editHistoryModalSave: "Salvar",
      editHistoryModalCancel: "Cancelar",
      editHistoryModalSucess: "Titulo atualizado com sucesso!",
      editHistoryErroToUpdateTitle: "Erro ao atualizar título:",
      editHistoryErroToUpdateAgentName: "Erro ao atualizar o nome do agente.",
      removeHistoryTitle: "Tem certeza?",
      removeHistoryAlert: "Você não poderá reverter isso!",
      removeHistoryConfirm: "Sim, remover!",
      removeHistoryCancel: "Cancelar",
      removeHistoryError: "Erro ao remover o agente:",
      removeHistorySuccess: "Removido com sucesso!",
      noDataMessage: "Não há dados a serem exibidos",
    },
    maintenanceAlert: {
      "title": "Aviso de Manutenção Programada",
      "greeting": "Prezado(a) usuário(a)",
      "message": "Informamos que a plataforma MJV Iron estará temporariamente indisponível para uma atualização de sistema. A interrupção ocorrerá a partir de 05/11, com retorno previsto para 06/11.",
      "importance": "Essa atualização é essencial para aprimorar a segurança e a performance da plataforma, oferecendo uma experiência ainda melhor para você.",
      "request": "Pedimos que organize suas atividades para evitar impactos durante esse período.",
      "thankYou": "Agradecemos pela compreensão e estamos à disposição para quaisquer dúvidas."
    },
  }
}